import React from "react";
import { Download, Package, CheckCircle2, AlertCircle, Compass } from "lucide-react";

// Page cachée de téléchargement du ZIP de déploiement, accès direct via /telecharger
export default function Telecharger() {
 const zipUrl = "/nanda-sa-static-build.zip";
 const catalogueUrl = "/nanda-sa-catalogue-complet.pdf";
 const kitUrl = "/nanda-sa-kit-post-lancement.pdf";
 const kitOppUrl = "/nanda-sa-kit-opportunites.zip";
 const dossierOppUrl = "/nanda-sa-opportunites-guinee-bissau.pdf";

 return (
 <div className="min-h-screen bg-nanda-bg" data-testid="page-telecharger">
 <div className="mx-auto max-w-3xl px-6 md:px-10 lg:px-14 py-24 md:py-32">
 <div className="label-overline text-nanda-terracotta mb-4">Téléchargement · Déploiement GoDaddy</div>
 <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] text-nanda-ink">
 Votre archive de déploiement.
 </h1>
 <p className="mt-8 text-nanda-inkSoft text-lg leading-relaxed">
 Cliquez sur le bouton ci-dessous pour télécharger la version finale du site NANDA SÁ,
 prête à être décompressée dans <code className="bg-nanda-sand px-2 py-0.5 text-nanda-ink text-sm">public_html/</code> de votre cPanel GoDaddy.
 </p>

 <div className="mt-14 border border-nanda-line bg-white p-10 md:p-14" data-testid="download-card">
 <div className="flex items-start justify-between mb-8">
 <Package size={40} strokeWidth={1.2} className="text-nanda-ink" />
 <div className="label-overline text-nanda-muted">v6.0 · Final</div>
 </div>
 <div className="font-serif text-3xl md:text-4xl text-nanda-ink">nanda-sa-static-build.zip</div>
 <div className="mt-2 label-overline text-nanda-muted">54 Mo · build de production optimisé · catalogue &amp; kit inclus</div>
 <div className="rule-gold w-24 my-8" />

 <a
 href={zipUrl}
 download="nanda-sa-static-build.zip"
 data-testid="download-btn"
 className="btn-arrow inline-flex items-center gap-4 bg-nanda-ink text-nanda-bg px-8 py-5 hover:bg-nanda-terracotta transition-colors duration-500 label-overline text-base"
 >
 <Download size={20} strokeWidth={1.5} />
 Télécharger le ZIP
 </a>

 <div className="mt-6 text-sm text-nanda-inkSoft">
 Si le bouton ne fonctionne pas, <a href={zipUrl} download className="text-nanda-terracotta underline underline-offset-4">cliquez ici</a> ou faites <em>clic droit → Enregistrer le lien sous...</em>
 </div>
 </div>

 <div className="mt-14 border border-nanda-line bg-white p-10 md:p-14" data-testid="catalogue-card">
 <div className="flex items-start justify-between mb-8">
 <Package size={40} strokeWidth={1.2} className="text-nanda-terracotta" />
 <div className="label-overline text-nanda-terracotta">Version complète · 55 pages</div>
 </div>
 <div className="font-serif text-3xl md:text-4xl text-nanda-ink">Catalogue officiel 2026-2027</div>
 <div className="mt-2 label-overline text-nanda-muted">PDF · 55 pages · 6 chapitres · Trilingue PT · FR · EN · Photos originales intégrées</div>
 <p className="mt-6 text-nanda-inkSoft leading-relaxed">
 Version complète du livre de marque NANDA SÁ, avec les premières photos de produits originaux
 désormais intégrées (NANDA SÁ Cosmétiques Hibiscus & Baobab, NANDA SÁ fleur de sel &amp; miel de mangrove, ENERGIA PRO
 installation solaire). Six chapitres : La Maison, les cinq Maisons, les gammes de produits, les services &amp; expertises,
 Pourquoi NANDA SÁ, contact. Les visuels manquants restent en placeholder discret,
 prêts à être remplacés au fur et à mesure de vos livraisons.
 </p>
 <div className="rule-gold w-24 my-8" />

 <a
 href={catalogueUrl}
 download="nanda-sa-catalogue-2026-2027.pdf"
 data-testid="catalogue-download-btn"
 className="btn-arrow inline-flex items-center gap-4 bg-nanda-terracotta text-white px-8 py-5 hover:bg-nanda-ink transition-colors duration-500 label-overline text-base"
 >
 <Download size={20} strokeWidth={1.5} />
 Télécharger le catalogue
 </a>
 </div>

 <div className="mt-14 border border-nanda-line bg-white p-10 md:p-14" data-testid="kit-card">
 <div className="flex items-start justify-between mb-8">
 <Compass size={40} strokeWidth={1.2} className="text-nanda-gold" />
 <div className="label-overline text-nanda-terracotta">Guide opérationnel · 22 pages</div>
 </div>
 <div className="font-serif text-3xl md:text-4xl text-nanda-ink">Kit post-lancement SEO</div>
 <div className="mt-2 label-overline text-nanda-muted">PDF · 22 pages · Search Console · Analytics 4 · GBP · Checklist 30 jours</div>
 <p className="mt-6 text-nanda-inkSoft leading-relaxed">
 Guide opérationnel pour accompagner la mise en ligne de nanda-sa.com. Six chapitres : Google Search
 Console, sitemap.xml, Google Analytics 4, création des fiches Google Business Profile pour les
 zones d'intervention (Canchungo · Bafatá), checklist SEO des 30 premiers jours
 et recommandations de référencement local en Guinée-Bissau. Descriptions prêtes à
 copier-coller, mots-clés cibles avec volumes, calendrier éditorial des 3 premiers mois.
 </p>
 <div className="rule-gold w-24 my-8" />

 <a
 href={kitUrl}
 download="nanda-sa-kit-post-lancement.pdf"
 data-testid="kit-download-btn"
 className="btn-arrow inline-flex items-center gap-4 bg-nanda-ink text-white px-8 py-5 hover:bg-nanda-terracotta transition-colors duration-500 label-overline text-base"
 >
 <Download size={20} strokeWidth={1.5} />
 Télécharger le kit
 </a>
 </div>

 <div className="mt-14 border border-nanda-line bg-white p-10 md:p-14" data-testid="kit-opp-card">
 <div className="flex items-start justify-between mb-8">
 <Package size={40} strokeWidth={1.2} className="text-nanda-terracotta" />
 <div className="label-overline text-nanda-terracotta">Kit complet · Nouveau</div>
 </div>
 <div className="font-serif text-3xl md:text-4xl text-nanda-ink">Kit Opportunités Guinée-Bissau</div>
 <div className="mt-2 label-overline text-nanda-muted">
 ZIP · Dossier PDF 11 pages · Carrousel LinkedIn 10 slides · Newsletter HTML · 10 publications FB &amp; IG
 </div>
 <p className="mt-6 text-nanda-inkSoft leading-relaxed">
 Le kit éditorial complet consacré aux opportunités économiques de la Guinée-Bissau : un dossier PDF haut de gamme
 destiné aux investisseurs et diasporas, un carrousel LinkedIn au format 1080&nbsp;px prêt à publier, une newsletter
 HTML responsive, et un carnet de 10 publications Facebook et Instagram prêtes à copier-coller. Tous les
 fichiers sont utilisables tels quels, dans un ordre de diffusion recommandé sur 5 semaines.
 </p>
 <div className="rule-gold w-24 my-8" />

 <div className="flex flex-wrap gap-4">
 <a
 href={kitOppUrl}
 download="nanda-sa-kit-opportunites.zip"
 data-testid="kit-opp-download-btn"
 className="btn-arrow inline-flex items-center gap-4 bg-nanda-ink text-white px-8 py-5 hover:bg-nanda-terracotta transition-colors duration-500 label-overline text-base"
 >
 <Download size={20} strokeWidth={1.5} />
 Télécharger le kit complet
 </a>
 <a
 href={dossierOppUrl}
 download="nanda-sa-opportunites-guinee-bissau.pdf"
 data-testid="dossier-opp-download-btn"
 className="btn-arrow inline-flex items-center gap-4 bg-transparent border border-nanda-ink text-nanda-ink px-8 py-5 hover:bg-nanda-ink hover:text-white transition-colors duration-500 label-overline text-base"
 >
 <Download size={20} strokeWidth={1.5} />
 Dossier PDF seul
 </a>
 </div>
 </div>

 <div className="mt-14 space-y-6">
 <h2 className="font-serif text-3xl text-nanda-ink">Contenu de l'archive</h2>
 <ul className="space-y-3 text-nanda-inkSoft">
 {[
 "index.html, page d'entrée avec meta SEO et Schema.org",
 "static/js/ + static/css/, bundle React optimisé (gzippé)",
 ".htaccess, routing SPA, gzip, cache, HTTPS, sécurité (fichier caché)",
 "sitemap.xml, sitemap trilingue FR/EN/PT avec hreflang",
 "robots.txt. SEO + blocage crawlers IA",
 "site.webmanifest. PWA manifest",
 "favicon.svg, icône vectorielle",
 "nanda-sa-catalogue-complet.pdf, catalogue officiel 54 pages",
 "nanda-sa-kit-post-lancement.pdf, kit SEO 22 pages",
 "nanda-sa-style-guide.pdf, charte graphique 6 pages",
 ].map((item, i) => (
 <li key={i} className="flex gap-3 items-baseline">
 <CheckCircle2 size={16} strokeWidth={1.5} className="text-nanda-terracotta shrink-0 translate-y-0.5" />
 <span>{item}</span>
 </li>
 ))}
 </ul>
 </div>

 <div className="mt-14 border-l-2 border-nanda-terracotta pl-6 py-2">
 <div className="flex items-baseline gap-3 mb-3">
 <AlertCircle size={18} strokeWidth={1.5} className="text-nanda-terracotta shrink-0 translate-y-1" />
 <h3 className="font-serif text-2xl text-nanda-ink">Étape importante après extraction</h3>
 </div>
 <p className="text-nanda-inkSoft leading-relaxed">
 Dans le File Manager de GoDaddy, activez <strong>Settings → Show Hidden Files</strong> pour vérifier
 que le fichier <code className="bg-nanda-sand px-2 py-0.5 text-nanda-ink text-sm">.htaccess</code> a bien été extrait.
 Ce fichier est essentiel, sans lui, les URL du type <code className="bg-nanda-sand px-2 py-0.5 text-nanda-ink text-sm">/cosmetiques</code> renverront une erreur 404.
 </p>
 </div>

 <div className="mt-14 space-y-6">
 <h2 className="font-serif text-3xl text-nanda-ink">Déploiement en 5 étapes</h2>
 <ol className="space-y-4 text-nanda-inkSoft">
 {[
 "Cliquez sur le bouton bleu ci-dessus pour télécharger le ZIP.",
 "Connectez-vous à votre GoDaddy cPanel puis ouvrez le File Manager.",
 "Naviguez vers public_html/ (ou le dossier lié à nanda-sa.com).",
 "Uploadez le ZIP puis clic droit → Extract.",
 "Activez « Show Hidden Files » et vérifiez que.htaccess est présent.",
 ].map((item, i) => (
 <li key={i} className="flex gap-4 items-baseline">
 <span className="font-serif text-2xl text-nanda-terracotta num-editorial shrink-0">0{i + 1}</span>
 <span className="leading-relaxed">{item}</span>
 </li>
 ))}
 </ol>
 </div>
 </div>
 </div>
 );
}
